import { hasAnswerContent, type RecordResponseRequest } from '@assessments/shared'

// Client-side answer validation, surfaced ONLY by Mark Complete; save state never carries it.

/** An answer counts as answered when it has non-blank text, at least one option, or a chosen Sub-Industry. */
export function isAnswered(answer: RecordResponseRequest): boolean {
  const hasIndustry = typeof answer.subIndustryId === 'string'
  return hasAnswerContent(answer.response, answer.selectedOptionIds.length) || hasIndustry
}

/**
 * The required question ids still unanswered — the Mark Complete gate computed
 * client-side from the current answers. A missing answer counts as unanswered.
 * Mirrors the server's required-answered gate (section-completion) so the UI can
 * pre-flight completion without a round-trip; the server remains the source of truth.
 */
export function findUnansweredRequired(
  requiredQuestionIds: string[],
  answers: Record<string, RecordResponseRequest>,
): string[] {
  return requiredQuestionIds.filter((id) => {
    const answer = answers[id]
    return !answer || !isAnswered(answer)
  })
}
